export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5587.4d144dba.jpg";